<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Recupera tu contraseña</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container" size="12" *ngIf="status === 'recovery'">
    <div class="ion-padding">
      <h1 class="ion-text-center">Recupera tu contraseña</h1>
      <ion-text class="ion-padding" color="medium">
        <p class="ion-text-center"><strong>Introduce el correo electrónico asociado a tu cuenta</strong></p>
        <ul class="ion-padding-horizontal">
          <li>No olvides revisar la carpeta de SPAM.</li>
          <li>Sigue las instrucciones proporcionadas en el correo.</li>
          <li>Regresa e inicia sesión con tu nueva contraseña</li>
        </ul>
      </ion-text>
      <!-- <div class="ion-padding-top"></div> -->
      <form *ngIf="form" (ngSubmit)="onSubmit()" [formGroup]="form" class="ion-padding">
        <ion-item lines="none" class="input ion-margin-vertical">
          <ion-input
            #inputEmail
            label="Email"
            labelPlacement="floating"
            type="text"
            placeholder="Email"
            formControlName="email"
          ></ion-input>
        </ion-item>
        <ion-button [disabled]="form.invalid" class="ion-margin-top" type="submit" expand="block">
          <ion-icon slot="start" name="mail-outline"></ion-icon>
          Enviar correo
        </ion-button>
      </form>
    </div>
  </div>

  <div class="container" size="12" *ngIf="status === 'migrate'">
    <div class="ion-padding">
      <h1 class="ion-text-center">Actualiza tu contraseña</h1>
      <ion-text class="ion-padding" color="medium">
        <p class="ion-text-center"><strong>Introduce el correo electrónico asociado a tu cuenta</strong></p>
        <ul class="ion-padding-horizontal">
          <li>Bienvenido a CMillonario.mx, por seguridad es necesario definir tu contraseña.</li>
          <li>Te enviamos un correo, sigue las instrucciones proporcionadas.</li>
          <li>Regresa e inicia sesión con tu nueva contraseña.</li>
        </ul>
      </ion-text>
      <!-- <div class="ion-padding-top"></div> -->
      <form *ngIf="form" (ngSubmit)="onSubmit()" [formGroup]="form" class="ion-padding">
        <ion-item lines="none" class="input ion-margin-vertical">
          <ion-input
            #inputEmail
            label="Email"
            labelPlacement="floating"
            type="text"
            placeholder="Email"
            formControlName="email"
          ></ion-input>
        </ion-item>
        <ion-button [disabled]="form.invalid" class="ion-margin-top" type="submit" expand="block">
          <ion-icon slot="start" name="mail-outline"></ion-icon>
          Enviar correo
        </ion-button>
      </form>
    </div>
  </div>
</ion-content>
